import { render, staticRenderFns } from "./MessageDetail.vue?vue&type=template&id=7d8bb312&scoped=true"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"
import style0 from "./MessageDetail.vue?vue&type=style&index=0&id=7d8bb312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8bb312",
  null
  
)

export default component.exports